import React, { Fragment, useState } from "react";
import { useEffect } from "react";
import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  Row,
  Spinner,
} from "reactstrap";
import ModalConID from "../ModalConID";
import { useInsertConText } from "../../Context/InsertContext";
import ModalUser from "../SetCommander/ModalUser";
import axios from "axios";
import { GetCookieData, GetCookieToken } from "../../Cookie/GetCookie";
import { FetchAxiosFile, FetchAxiosGet, FetchAxiosPost, FetchAxiosPut } from "../../../api/axios";
import ModalAssignUser from "../SetCommander/ModalAssignUser";
import LoadingData from "../../TESTPage/LoadingData";
import FadeIn from "react-fade-in/lib/FadeIn";
import { Link } from "react-router-dom";
import MyThaiDatePick from "../../../components/Common/ThaiDatePicker";
import ConfirmModal from "../../../components/Common/ConfirmModal";
import LoadingPerson from "../../TESTPage/LoadingPerson";

const API_URL = process.env.REACT_APP_API_CORS;

function AddAssign(props) {
  const { onButtonClick } = props;
  const { insert, setInsert } = useInsertConText();
  const [open, setOpen] = useState(false);

  const [loading, setLoading] = useState(true);
  const [userName, setUserName] = useState(null);
  const [userID, setUserID] = useState(null);
  const [userAssignName, setUserAssignName] = useState(null);
  const [userAssignID, setUserAssignID] = useState(null);
  // const [orgName, setOrgName] = useState(null);
  const [org, setOrg] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(null);
  const [status, setStatus] = useState(0);
  const [assignOption, setAssignOption] = useState("1");
  const [position_Name, setPosition_Name] = useState(null);
  const [position_ID, setPosition_ID] = useState(null);
  const [userAssignData, setUserAssignData] = useState(null);
  const [userAssignDataOrg, setUserAssignDataOrg] = useState(null);
  const [assignOrgId, setAssignOrgId] = useState(null);
  const [assignId, setAssignId] = useState(null);
  const [assignUserId, setAssignUserId] = useState(null);
  const [assignOrgName, setAssignOrgName] = useState(null);
  const [fileUp, setFileUp] = useState(null);
  const [masterdata, setMasterdata] = useState([]);
  const [alertFile, setAlertFile] = useState(false);
  const [alertsetAssignOrgId, setAlertsetAssignOrgId] = useState(false);
  const [selectedOrgIds, setSelectedOrgIds] = useState([]);

  // const [orgId, setOrgId] = useState([]);
  // const [orgName, setOrgName] = useState([]);
  const [organization, setOrganization] = useState([]);
  const [alertassignUserId, setAlertAssignUserId] = useState(false);
  const [alertassignUserName, setAlertAssignUserName] = useState(false);
  const [currentPositionID, setCurrentPositionID] = useState(null);
  const [currentPositionName, setCurrentPositionName] = useState(null);
  const [alertStartDate, setAlertStartDate] = useState(false);
  const [alertUserName, setAlertUserName] = useState(false);
  const [userNumber, setUserNumber] = useState(1);
  const [positionCheck, setPositionCheck] = useState(0);
  const [positionID1Check, setPositionID1Check] = useState(0);
  const [positionID2Check, setPositionID2Check] = useState(0);
  const [positionID3Check, setPositionID3Check] = useState(0);
  const [positionID4Check, setPositionID4Check] = useState(0);
  const [positionID5Check, setPositionID5Check] = useState(0);
  const [positionID6Check, setPositionID6Check] = useState(0);
  const [positionID7Check, setPositionID7Check] = useState(0);

  const [selectOrg, setSelectOrg] = useState({
    condition:false,
    value:null,
  })

  const [assignOrg, setAssignOrg] = useState(null);

  const [optionPosition, setOptionPosition] = useState([])

  const [confirmModal, setconfirmModal] = useState(false)

  const token = GetCookieToken("userToken");

  const positionURL = "/api/users/position/save";

  const toggleRightCanvasT = () => {
    setLoading(true);

    setUserAssignName(null);
    setUserAssignID(null);
    setAssignUserId(null);
    setUserID(null);
    setUserName(null);
    setOrganization([]);
    setOptionPosition([]);
    setSelectOrg({
      condition:false,
      value:null,
    });
    // setOrgId(null);
    // setOrgName(null);
    setOpen(!open);
    fetchMasterData();
    setTimeout(() => {
      setLoading(false);
    }, 1500);
  };

  const toggleRightCanvasF = () => {
    setLoading(true);
    onButtonClick();
    setTimeout(() => {
      setLoading(false);
      setOpen(!open);
    }, 2500);
  };

  const toggleRightCanvasFS = () => {
    setLoading(true);
    handleClearFile();
    // setOrg(null);
    setOrganization([]);
    setOptionPosition([]);
    setSelectOrg({
      condition:false,
      value:null,
    });
    setUserAssignName(null);
    setUserAssignID(null);
    setAssignUserId(null);
    setUserID(null);
    setUserName(null);
    setAlertFile(false);
    setAlertUserName(false);
    setAlertAssignUserId(false);
    setAlertStartDate(false);
    setAlertsetAssignOrgId(false);
    setAlertAssignUserName(false);
    setUserAssignDataOrg(null);
    setUserAssignData(null);
    setAssignId(null);
    setAssignOption("1");
    setTimeout(() => {
      setLoading(false);

      setOpen(!open);
    }, 1000);
  };

  const fetchMasterData = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/users/config/all`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setMasterdata(response.data.result);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const data = {
    position_id: position_ID,
    position_name: position_Name,
    user_id: userID,
    is_default: 0,
    date_start: startDate,
    date_end: endDate,
    org_id: assignOrgId,
    status: status,
    assigned_by_user_id: assignUserId,
    assign: 1,
    assign_org_id: assignId,
    number: userNumber,
    assign_type: 1, // ปฏิบัติราชการแทน
  };

  const handleSubmit = async () => {
    if (  userID !== null && assignUserId !== null && status !== null && assignOrgId !== null && startDate !== null) {
      if (assignOption === "1") {
        setLoading(true);
        FetchAxiosPost(positionURL, data, token)
          .then(item => {
            if (fileUp !== null) {
              const url_file = `/api/users/position/file/${item}`;
              FetchAxiosFile(url_file, token, fileUp);
            }
          })
          .catch(error => {
            console.error(error);
          });
        setUserAssignName(null);
        setUserAssignID(null);
        setAssignUserId(null);
        setUserID(null);
        setUserName(null);
        setAlertFile(false);
        setOrganization([]);
        setOptionPosition([]);
        setSelectOrg({
          condition:false,
          value:null,
        });
        setAlertAssignUserId(false);
        setAlertAssignUserName(false);
        setOrg(null);
        setAlertStartDate(false);
        setAlertsetAssignOrgId(false);
        setUserAssignDataOrg(null);
        setUserAssignData(null);
        setAssignId(null);
        toggleRightCanvasF();
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    } else {
      if (fileUp === null) {
        setAlertFile(true);
      }

      if (assignUserId === null) {
        setAlertAssignUserId(true);
      }
      if (userAssignName === null) {
        setAlertAssignUserName(true);
      }

      if (startDate === null) {
        setAlertStartDate(true);
      }
      if (assignOrgId === null) {
        setAlertsetAssignOrgId(true);
      }
      if (userName === null) {
        setAlertUserName(true);
      }
    }
    if (assignOption === "0" ) {
      // optionPosition.map(i => { //กรณีรักษา ตน.มากกว่า 1 องค์กร
        organization.map(async (i) => {
        const data = {
          position_id: currentPositionID,
          position_name: currentPositionName,
          user_id: userID,
          is_default: 0,
          date_start: startDate,
          date_end: endDate,
          org_id: i.org_id,
          status: status,
          assign: 1,
          assign_org_id: i.org_id,
          assign_type: 0, // รักษาราชการ
        };
        setLoading(true);
        const url = "/api/users/position/datatable";
        const params = new URLSearchParams({
          page: 1,
          size: 10,
          "order[0]": "position_id",
          "order[1]": "ASC",
          "filter[position_id][0]": currentPositionID,
          "filter[org_id][0]": i.org_id,
          "filter[status][0]": 1,
        });
        const resp = await FetchAxiosGet(url,token, params)
        if (resp?.result?.length > 0) {
          for (let index = 0; index < resp.result.length; index++) {
            const element = resp.result[index];
            if (Number(userID) !== Number(element.user_id)) {
              const originalDate = new Date(startDate);
              originalDate.setDate(originalDate.getDate() - 1);
              const urlEdit = `/api/users/position/${element.id}`
              const dataEdit =  {
                position_id: element.position_id,
                position_name: element.position_name,
                user_id: element.user_id,
                is_default: element.is_default,
                date_start: element.date_start,
                date_end: originalDate.toISOString(),
                status: "0",
              }
              const fetchEditCancelDate = await FetchAxiosPut(urlEdit,dataEdit,token)
            }
          }
        }
        FetchAxiosPost(positionURL, data, token)
          .then(item => {
            if (fileUp !== null) {
              const url_file = `/api/users/position/file/${item}`;
              FetchAxiosFile(url_file, token, fileUp);
            }
          })
          .catch(error => {
            console.error(error);
          });
      });

      setUserAssignName(null);
      setUserAssignID(null);
      setAssignUserId(null);
      setUserID(null);
      setUserName(null);
      setAlertFile(false);

      setAlertAssignUserId(false);
      setAlertAssignUserName(false);
      setOrg(null);
      setAlertStartDate(false);
      setAlertsetAssignOrgId(false);
      setUserAssignDataOrg(null);
      setUserAssignData(null);
      setAssignId(null);
      toggleRightCanvasF();
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  useEffect(() => {
    const checkNlv = assignOrg?.find(i => i.org_id == organization[0]?.org_id)
    if (checkNlv?.nodelv == 1) {
      setCurrentPositionID(2)
      setCurrentPositionName("เลขาธิการ ก.พ.ร.")
    } else if (checkNlv?.nodelv == 2) {
      setCurrentPositionID(5)
      setCurrentPositionName("ผู้อำนวยการกอง")
    } else if (checkNlv?.nodelv == 3) {
      setCurrentPositionID(7)
      setCurrentPositionName("ผู้เชี่ยวชาญกลุ่ม/หัวหน้ากลุ่ม")
    }
  }, [organization])

  useEffect(() => {
    if (insert.task === "สำนัก/กอง/กลุ่ม_ผู้บังคับบัญชา") {
      // กรณีรักษามากกว่า 1 องค์กร
      // setOrganization(prev => [...prev?.filter(x => x.org_id !== insert.insert_id) , {org_id: insert.insert_id, org_name: insert.insert_name}])
      setOrganization([{org_id: insert.insert_id, org_name: insert.insert_name}])
    }
    if (insert.task === "user_ผู้บังคับบัญชา") {
      setUserID(insert.insert_id);
      setUserName(insert.insert_name);
      setAlertUserName(false);
    }
    if (insert.task === "Assign_ผู้บังคับบัญชา") {
      setUserAssignName(insert.insert_name);
      setUserAssignID(insert.insert_id);
      setAlertAssignUserName(false);
    }
  }, [insert]);

  const fetchPositionData = async () => {
    const url = "/api/users/position/datatable";
    const params = new URLSearchParams({
      page: 1,
      size: 10,
      "order[0]": "position_id",
      "order[1]": "ASC",
      // search: pushkeyword,
      "filter[user_id][0]": userID,
    });
    await FetchAxiosGet(url, token, params).then(res => {
      setPosition_ID(res.result[0]?.position_id);
      setPosition_Name(res.result[0]?.position_name);
    })
  }

  useEffect(() => {
    if (assignOption === "0") {
      // setUserAssignName("อ้อนฟ้า เวชชาชีวะ");
      setAssignUserId(851);
      if (userID) {
        fetchPositionData();
      }
    }
    if (assignOption === "1") {
      setUserAssignName(null);
      setUserAssignID(null);
      setUserAssignData(null);
    }
  }, [assignOption, userID]);

  useEffect(() => {
    const url = `${API_URL}/api/orgInner/level`;

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      // params,
    };
    axios
      .get(url, config)
      .then(response => {
        setOrg(response.data.result);
        const allNodelv = []
        allNodelv.push(response.data.result)
        response.data.result.child.map((item, idx) => {
          allNodelv.push(item)
          item.child.map((subItem, subIdx) => {
            allNodelv.push(subItem)
            subItem.child.map((sublv3, idx3) => {
              allNodelv.push(sublv3)
            })
          })
        })
        setAssignOrg(allNodelv)
      })
      .catch(error => console.error("Error:", error));
  }, []);

  const fetchUserData = id => {
    const url = `${API_URL}/api/users/position/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 10,
      "order[0]": "position_id",
      "order[1]": "ASC",
      // search: pushkeyword,
      "filter[user_id][0]": id,
    });
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    axios
      .get(url, config)
      .then(response => {
        setUserAssignData(response.data.result);
      })
      .catch(error => console.error("Error:", error));
  };

  const fetchOrgIdData = (assign_id, id) => {
    const url = `${API_URL}/api/users/position/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 10,
      "order[0]": "position_id",
      "order[1]": "ASC",
      // search: pushkeyword,
      "filter[id][0]": assign_id,
      "filter[user_id][0]": id,
    });
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    axios
      .get(url, config)
      .then(response => {
        setUserAssignDataOrg(response.data.result);
      })
      .catch(error => console.error("Error:", error));
  };

  useEffect(() => {
    if (userAssignID !== null) {
      fetchUserData(userAssignID);
    }
  }, [userAssignID]);

  useEffect(() => {
    if (assignId !== null) {
      fetchOrgIdData(assignId, userAssignID);
    }
  }, [assignId]);

  const handleButtonFileClick = () => {
    const fileInput = document.getElementById("file-input");

    if (fileInput) {
      fileInput.click();
    }
  };

  const handleFileChange = e => {
    const file = e.target.files[0];

    if (file) {
      setFileUp(file);
      setAlertFile(false);
    }
  };

  const handleClearFile = e => {
    const fileInput = document.getElementById("file-input");
    if (fileInput) {
      fileInput.value = null;
      setFileUp(null);
    }
  };

  useEffect(() => {
    if (userAssignDataOrg !== null) {
      const EditPositonCheck = userAssignDataOrg?.map(
        userOrgData => userOrgData.position_id
      );
      if (`${EditPositonCheck}` === "1") {
        setPositionCheck(1);
        setPositionID1Check(2);
        setPositionID2Check(3);
        setPositionID3Check(4);
        setPositionID4Check(5);
        setPositionID5Check(6);
        setPositionID6Check(7);
        setPositionID7Check(8);
      }
      if (`${EditPositonCheck}` === "2") {
        setPositionCheck(2);
        setPositionID1Check(1);
        setPositionID2Check(3);
        setPositionID3Check(4);
        setPositionID4Check(5);
        setPositionID5Check(6);
        setPositionID6Check(7);
        setPositionID7Check(8);
      }
      if (`${EditPositonCheck}` === "3") {
        setPositionCheck(3);
        setPositionID1Check(2);
        setPositionID2Check(1);
        setPositionID3Check(4);
        setPositionID4Check(5);
        setPositionID5Check(6);
        setPositionID6Check(7);
        setPositionID7Check(8);
      }
      if (`${EditPositonCheck}` === "4") {
        setPositionCheck(4);
        setPositionID1Check(2);
        setPositionID2Check(3);
        setPositionID3Check(1);
        setPositionID4Check(5);
        setPositionID5Check(6);
        setPositionID6Check(7);
        setPositionID7Check(8);
      }
      if (`${EditPositonCheck}` === "5") {
        setPositionCheck(5);
        setPositionID1Check(2);
        setPositionID2Check(3);
        setPositionID3Check(4);
        setPositionID4Check(1);
        setPositionID5Check(6);
        setPositionID6Check(7);
        setPositionID7Check(8);
      }
      if (`${EditPositonCheck}` === "6") {
        setPositionCheck(6);
        setPositionID1Check(2);
        setPositionID2Check(3);
        setPositionID3Check(4);
        setPositionID4Check(5);
        setPositionID5Check(1);
        setPositionID6Check(7);
        setPositionID7Check(8);
      }
      if (`${EditPositonCheck}` === "7") {
        setPositionCheck(7);
        setPositionID1Check(2);
        setPositionID2Check(3);
        setPositionID3Check(4);
        setPositionID4Check(5);
        setPositionID5Check(6);
        setPositionID6Check(1);
        setPositionID7Check(8);
      }
      if (`${EditPositonCheck}` === "8") {
        setPositionCheck(8);
        setPositionID1Check(2);
        setPositionID2Check(3);
        setPositionID3Check(4);
        setPositionID4Check(5);
        setPositionID5Check(6);
        setPositionID6Check(7);
        setPositionID7Check(1);
      }
    }
  }, [userAssignDataOrg]);

  useEffect(() => {
    if (userAssignData !== null) {
      const configPoID = userAssignDataOrg?.map(assign => assign.position_id);

      const foundData = masterdata.users_position.find(
        i => i.users_position_id === parseInt(configPoID)
      );
      setPosition_ID(foundData?.users_position_id);
      setPosition_Name(foundData?.users_position_name);
    }
  }, [userAssignDataOrg]);

  const handleInputChange = e => {
    const value = parseInt(e.target.value, 10);

    if (value >= 1 && value <= 5) {
      setUserNumber(value); // อัปเดตค่าใน state
    }
  };

  // useEffect(() => {
  //   console.log(optionPosition)
  // }, [optionPosition])
  
  // กรณีมีการรักษา ตน. มากกว่า 1 องค์กร
  // const deleteOrgSelected = (indx) => {
  //   const updatedOrganizations = organization.filter(org => org.org_id !== indx)
  //   setOrganization(updatedOrganizations)
  //   let updatedOptionPosition = []
  //   if (optionPosition.length > 0) {
  //       updatedOptionPosition = optionPosition.filter(org => org.org_id !== indx)
  //       setOptionPosition(updatedOptionPosition)
  //   }
  // }

  return (
    <Fragment>
      <ConfirmModal
        modal = {confirmModal}
        modalSize = "md"
        modalHeaderContent = "คุณต้องการที่จะเพิ่มการปฏิบัติราชการแทนใช่หรือไม่?"
        onClickConfirmBtn={() => {
         handleSubmit();
         setconfirmModal(false)
        }}
        onClickCancelBtn={() => {
          setconfirmModal(false)
        }}
      />
      <Button
        className="mt-1 mb-2"
        onClick={toggleRightCanvasT}
        color="primary"
      >
        <i className="fa-solid fa-user-plus me-1"></i> เพิ่มใหม่
      </Button>
      <Offcanvas
        style={{ border: "none" }}
        autoFocus
        direction="end"
        isOpen={open}
        toggle={toggleRightCanvasFS}
        fade
        className="fade custom-w-50"
      >
        <OffcanvasHeader style={{ background: "#2a3042", color: "white" }}>
          <i className="fa-solid fa-plus"></i> กำหนดการปฏิบัติราชการแทน
          <div className="position-absolute top-0 end-0">
            <i className="fa-sharp fa-solid fa-circle-xmark pt-3 pe-3 h4" style={{cursor: "pointer"}} onClick={toggleRightCanvasFS}></i>
          </div>
        </OffcanvasHeader>
        <OffcanvasBody>
          {loading ? (
            <LoadingPerson />
          ) : (
            <Form
              onSubmit={e => {
                e.preventDefault();
                setconfirmModal(true)
              }}
            >
              {assignOption === "1" ? (
                <Row>
                  <Col lg={2}>
                    <FormGroup>
                      <Label>ลำดับ</Label>
                      <InputGroup style={{ width: "50px" }}>
                        <Input
                          name="user_number"
                          value={userNumber}
                          type="number"
                          onChange={handleInputChange}
                        />
                      </InputGroup>
                    </FormGroup>
                  </Col>
                </Row>
              ) : (
                ""
              )}

              <Row>
                <Col lg={12}>
                  <FormGroup>
                    <Label>ผู้รับมอบอำนาจ</Label>
                    <InputGroup className="z-0">
                      <Input
                        readOnly
                        defaultValue={userName}
                        name="user_name"
                        placeholder=""
                        type="text"
                        invalid={!userName}
                      />
                      <ModalUser task="user_ผู้บังคับบัญชา" showSelectedAllMenu={true}/>
                    </InputGroup>
                  </FormGroup>
                </Col>
              </Row>
              {alertUserName === true ? (
                <Row className="mb-2">
                  <Col lg={12}>
                    <div id="liveAlertPlaceholder">
                      <Alert
                        color="danger"
                        className="text-danger"
                        isOpen={alertUserName}
                      >
                        กรุณาเลือก ผู้รับมอบอำนาจ
                      </Alert>
                    </div>
                  </Col>
                </Row>
              ) : (
                ""
              )}

              <Row>
                <Col lg={6}>
                  <InputGroup className="my-2">
                    <Input
                      readOnly
                      type="select"
                      placeholder="Check it out"
                      defaultValue="ปฏิบัติราชการแทน"
                      style={{
                        cursor: "pointer",
                        transition: "background-color 0.3s",
                      }}
                      onChange={e => setAssignOption(e.target.value)}
                    >
                      <option value="1">มอบหมายปฏิบัติราชการแทน</option>
                      <option value="0">มอบหมายรักษาราชการแทน</option>
                    </Input>
                  </InputGroup>
                </Col>
              </Row>
              {assignOption === "1" ? (
                <Fragment>
                  <Row>
                    <Col lg={12}>
                      <FormGroup>
                        <Label>ผู้มอบอำนาจ</Label>
                        <InputGroup className="z-0">
                          <Input
                            readOnly
                            defaultValue={userAssignName}
                            name="user_name"
                            placeholder=""
                            type="text"
                            invalid={!userAssignName}
                          />
                          <ModalAssignUser task="Assign_ผู้บังคับบัญชา" showSelectedAllMenu={true}/>
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                  {alertassignUserName === true ? (
                    <Row className="mb-2">
                      <Col lg={12}>
                        <div id="liveAlertPlaceholder">
                          <Alert
                            color="danger"
                            className="text-danger"
                            isOpen={alertassignUserName}
                          >
                            กรุณาเลือก ผู้มอบอำนาจ
                          </Alert>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                  {userAssignData !== null ? (
                    <Fragment>
                      <Row>
                        <Col lg={12}>
                          <FormGroup>
                            {userAssignData !== null
                              ? userAssignData[0]?.assign === 0 && (
                                  <Label>
                                    สำนัก/กอง/กลุ่ม ที่ได้รับการดูแล
                                  </Label>
                                )
                              : ""}
                            {userAssignData?.map((assignData, index) => {
                              if (assignData.assign === 0) {
                                return (
                                  <InputGroup className="my-2" key={index}>
                                    <InputGroupText>
                                      <Input
                                        addon
                                        type="radio"
                                        defaultChecked={assignData.id === assignId}
                                        name="users_position_id"
                                        onChange={e => {
                                          setAssignId(
                                            e.target.checked
                                              ? assignData.id
                                              : null
                                          );
                                          setAssignUserId(
                                            e.target.checked
                                              ? assignData.user_id
                                              : null
                                          );
                                          setAssignOrgId(
                                            e.target.checked
                                              ? assignData.org_id
                                              : null
                                          );

                                          setAssignOrgName(
                                            e.target.checked
                                              ? assignData.org_name
                                              : null
                                          );
                                          setAlertsetAssignOrgId(
                                            e.target.checked ? false : null
                                          );
                                        }}
                                      />
                                    </InputGroupText>
                                    <Input
                                      readOnly
                                      defaultValue={assignData.org_name}
                                      style={{
                                        cursor: "pointer",
                                        transition: "background-color 0.3s",
                                      }}
                                    />
                                  </InputGroup>
                                );
                              }
                            })}
                          </FormGroup>
                        </Col>
                      </Row>
                      {alertsetAssignOrgId === true ? (
                        <Row className="mb-2">
                          <Col lg={12}>
                            <div id="liveAlertPlaceholder">
                              <Alert
                                color="danger"
                                className="text-danger"
                                isOpen={alertFile}
                              >
                                กรุณาเลือก สำนัก/กอง/กลุ่ม ที่ได้รับการดูแล
                              </Alert>
                            </div>
                          </Col>
                        </Row>
                      ) : (
                        ""
                      )}

                      {assignId !== null ? (
                        <Row>
                          <Col lg={12}>
                            <FormGroup>
                              <Label>ตำแหน่ง ที่ได้รับการดูแล</Label>
                              {userAssignDataOrg?.map((assign, assignIndex) => {
                                return (
                                  <>
                                    {masterdata.users_position?.map(
                                      (config, configIndex) => (
                                        <InputGroup
                                          className="my-2"
                                          key={`assign_${assignIndex}_config_${configIndex}`}
                                        >
                                          {config.users_position_id !== 1 &&
                                          config.users_position_id !== 8 ? (
                                            assign.position_id ===
                                              positionCheck &&
                                            config.users_position_id !==
                                              positionID1Check &&
                                            config.users_position_id !==
                                              positionID2Check &&
                                            config.users_position_id !==
                                              positionID3Check &&
                                            config.users_position_id !==
                                              positionID4Check &&
                                            config.users_position_id !==
                                              positionID5Check &&
                                            config.users_position_id !==
                                              positionID6Check &&
                                            config.users_position_id !==
                                              positionID7Check ? (
                                              <>
                                                <InputGroupText>
                                                  <Input
                                                    disabled
                                                    // defaultChecked
                                                    type="radio"
                                                    name="users_position_id"
                                                    onChange={e => {
                                                      setPosition_ID(
                                                        e.target.checked
                                                          ? config.users_position_id
                                                          : null
                                                      );
                                                      setPosition_Name(
                                                        e.target.checked
                                                          ? config.users_position_name
                                                          : null
                                                      );
                                                    }}
                                                  />
                                                </InputGroupText>
                                                <Input
                                                  readOnly
                                                  defaultValue={
                                                    config.users_position_name
                                                  }
                                                  style={{
                                                    cursor: "pointer",
                                                    transition:
                                                      "background-color 0.3s",
                                                  }}
                                                />
                                              </>
                                            ) : config.users_position_id !==
                                              positionCheck ? (
                                              <>
                                                <InputGroupText
                                                  key={`assign_1${assignIndex}_config_${configIndex}`}
                                                >
                                                  <Input
                                                    disabled
                                                    addon
                                                    type="radio"
                                                    name="users_position_id"
                                                    onChange={e => {
                                                      setPosition_ID(
                                                        e.target.checked
                                                          ? config.users_position_id
                                                          : null
                                                      );

                                                      setPosition_Name(
                                                        e.target.checked
                                                          ? config.users_position_name
                                                          : null
                                                      );
                                                    }}
                                                  />
                                                </InputGroupText>
                                                <Input
                                                  readOnly
                                                  defaultValue={
                                                    config.users_position_name
                                                  }
                                                  style={{
                                                    cursor: "pointer",
                                                    transition:
                                                      "background-color 0.3s",
                                                  }}
                                                />
                                              </>
                                            ) : (
                                              ""
                                            )
                                          ) : (
                                            ""
                                          )}
                                        </InputGroup>
                                      )
                                    )}
                                  </>
                                );
                              })}
                            </FormGroup>
                          </Col>
                        </Row>
                      ) : (
                        ""
                      )}
                    </Fragment>
                  ) : (
                    ""
                  )}
                </Fragment>
              ) : assignOption === "0" ? (
                <Fragment>
                  <Row>
                    <Col lg={12}>
                      <FormGroup>
                        <Label>สำนัก/กอง/กลุ่ม ที่ได้รับการดูแล</Label>
                          <InputGroup>
                            <Input
                              readOnly
                              defaultValue={organization && organization[organization?.length - 1]?.org_name}
                              name="org_name"
                              placeholder=""
                              type="text"
                              invalid={organization?.length == 0 && !organization[organization?.length - 1]?.org_name}
                            />
                            <ModalConID task="สำนัก/กอง/กลุ่ม_ผู้บังคับบัญชา" taskFilter = "NEED_ADMINISTER"/>
                          </InputGroup>
                          {organization?.length == 0 && !organization[organization?.length - 1]?.org_name && <FormFeedback>โปรดกรอกข้อมูล</FormFeedback>}
                      </FormGroup>
                    </Col>
                  </Row>

                  {/* กรณีรักษาตน.มากกว่า 1 องกรณ์ */}
                  {/* {organization && organization?.length > 0 &&
                    organization?.map((item,idx) => {
                      return(
                        <Row key={idx}>
                          <Col lg={12}>
                            <FormGroup>
                                <InputGroup>
                                  <InputGroupText>
                                    <Input
                                      addon
                                      type="radio"
                                      name="org_name"
                                      placeholder=""
                                      onChange={(e) => {
                                        setSelectOrg({ condition: e.target.checked, value: item.org_id });
                                      }}
                                    />
                                  </InputGroupText>
                                  <Input readOnly value={item?.org_name}/>
                                  <InputGroupText className="p-0">
                                    <Button className="rounded-start-0" color="danger" onClick={() => {deleteOrgSelected(item.org_id)}}><i className="fa-solid fa-trash"></i></Button>
                                  </InputGroupText>
                                </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>
                      )
                    })
                  }

                  {organization && organization.length > 0 && 
                    organization?.map((item,idx) => {
                      if (item.org_id == selectOrg.value) {
                        return(
                          masterdata.users_position?.map((masterdata, index) =>
                            masterdata.users_position_id !== 1 ? (
                              <>
                                <InputGroup className="my-2" key={index}>
                                  <InputGroupText>
                                    <Input
                                      addon
                                      type="radio"
                                      disabled={!selectOrg?.condition}
                                      name="users_position_id"
                                      defaultChecked={optionPosition?.find(y => y.idx == idx && y.position_id == masterdata.users_position_id)}
                                      onChange={e => {
                                          setOptionPosition((prev) => [...prev?.filter(x => x.idx !== idx), {
                                            position_id: e.target.checked ? masterdata.users_position_id : null,
                                            position_name: e.target.checked ? masterdata.users_position_name : null,
                                            org_id: selectOrg?.value,
                                            idx: idx
                                          }]);
                                      }}
                                    />
                                  </InputGroupText>
                                  <Input
                                    readOnly
                                    defaultValue={masterdata.users_position_name}
                                    style={{
                                      cursor: "pointer",
                                      transition: "background-color 0.3s",
                                    }}
                                  />
                                </InputGroup>
                              </>
                            ) : (
                              ""
                            )
                          )
                        )
                      }
                    })
                  } */}
                </Fragment>
              ) : (
                ""
              )}

              <Row>
                <Col lg={6}>
                  <FormGroup>
                    <Label>คำสั่งการมอบหมายตำแหน่งข้าราชการแทน</Label>
                    <br />
                    <Button
                      className=""
                      type="button"
                      onClick={handleButtonFileClick}
                    >
                      <i className="fa-solid fa-upload pe-2"></i>
                      อัพโหลดไฟล์
                    </Button>
                    <input
                      id="file-input"
                      type="file"
                      accept=".pdf*"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />
                  </FormGroup>
                  {fileUp !== null ? (
                    <Row className="mb-2">
                      <Col lg={12}>
                        <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                          <div className="p-2">
                            <Row className="align-items-center">
                              <Col className="col-auto">
                                <i
                                  className="fa-solid fa-file-pdf fa-2xl"
                                  style={{ color: "#f81212" }}
                                ></i>
                              </Col>
                              <Col>
                                <span
                                  className="text-muted font-weight-bold"
                                >
                                  {fileUp.name}
                                </span>
                                <p className="mb-0">
                                  <strong>{fileUp.formattedSize}</strong>
                                </p>
                              </Col>
                              <Col className="col-auto">
                                <button
                                  type="button"
                                  className="btn btn-link btn-sm text-danger"
                                  onClick={() => {
                                    handleClearFile();
                                  }}
                                >
                                  <i className="fa-solid fa-xmark-large"></i>
                                </button>
                              </Col>
                            </Row>
                          </div>
                        </Card>
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                  {alertFile === true ? (
                    <Row className="mb-2">
                      <Col lg={12}>
                        <div id="liveAlertPlaceholder">
                          <Alert
                            color="danger"
                            className="text-danger"
                            isOpen={alertFile}
                          >
                            กรุณาแนบเอกสารคำสั่งการมอบหมายตำแหน่งข้าราชการแทน
                          </Alert>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                </Col>
                <Col lg={6}>
                  <br />
                  <InputGroup className="my-2">
                    <Input
                      readOnly
                      placeholder="Check it out"
                      defaultValue="ใช้งาน"
                      style={{
                        cursor: "pointer",
                        transition: "background-color 0.3s",
                      }}
                    />
                    <InputGroupText>
                      <Input
                        addon
                        type="checkbox"
                        name="user_commander"
                        onChange={e => {
                          setStatus(e.target.checked ? 1 : 0);
                        }}
                      />
                    </InputGroupText>
                  </InputGroup>
                </Col>
              </Row>

              <Row>
                <Col lg={6}>
                  <FormGroup>
                    <Label>วันที่เริ่ม</Label>
                    <MyThaiDatePick placeholderText = "เลือกวันที่เริ่มต้น..." setProbsDate = {setStartDate}/>
                  </FormGroup>
                </Col>

                <Col lg={6}>
                  <FormGroup>
                    <Label>วันที่สิ้นสุด</Label>
                    <MyThaiDatePick minDate = {startDate} placeholderText = "เลือกวันที่สิ้นสุด..." setProbsDate = {setEndDate}/>
                  </FormGroup>
                </Col>
              </Row>
              {alertStartDate === true ? (
                <Row className="mb-2">
                  <Col lg={6}>
                    <div id="liveAlertPlaceholder">
                      <Alert
                        color="danger"
                        className="text-danger"
                        isOpen={alertStartDate}
                      >
                        กรุณากรอกวันที่เริ่ม
                      </Alert>
                    </div>
                  </Col>
                </Row>
              ) : (
                ""
              )}

              <br />
              <Row>
                <Col md={4} lg={6} xl={6}></Col>
                <Col xs={12} sm={12} md={4} lg={3} xl={3} style={{ display: "flex", justifyContent: "end" }} className="mb-2">
                  <Button type="submit" color="success" style={{ width: "100%" }} disabled={!userName && (organization?.length == 0 && !organization[organization?.length - 1]?.org_name) && !userAssignName}>บันทึก</Button>
                </Col>
                <Col xs={12} sm={12} md={4} lg={3} xl={3} style={{ display: "flex", justifyContent: "end" }} className="mb-2">
                  <Button color="danger" style={{ width: "100%" }} onClick={toggleRightCanvasFS}>ยกเลิก</Button>
                </Col>
              </Row>
            </Form>
          )}
        </OffcanvasBody>
      </Offcanvas>
    </Fragment>
  );
}

export default AddAssign;
